export default {"src":"/_next/static/media/key-statistic.de50c620.svg","height":132,"width":214,"blurWidth":0,"blurHeight":0};